import React, { memo } from 'react';
import FormHelperText from '@mui/material/FormHelperText';
import { useTranslation } from 'react-i18next';

import { FormControlCustom, InputAutocompletCustom, InputCustom } from './styled';

export interface OptionsProps {
  title: string;
  value: string;
}

interface Props {
  label?: string;
  name: string;
  options: OptionsProps[];
  value?: OptionsProps | null;
  error?: boolean;
  noOptionsText?: string;
  helperText?: string;
  disabled?: boolean;
  onChange: (name: string, value: OptionsProps | null) => void;
}

const InputAutocomplete: React.FC<Props> = ({
  options,
  label,
  name,
  value,
  error,
  noOptionsText,
  helperText,
  disabled,
  onChange,
}) => {
  const { t: translate } = useTranslation();
  return (
    <FormControlCustom variant="outlined">
      <InputAutocompletCustom<OptionsProps>
        disablePortal
        disabled={disabled}
        id={name}
        options={options}
        value={value ?? null}
        getOptionLabel={(option) => option.title}
        isOptionEqualToValue={(option, val) => option.value === val.value}
        onChange={(_, newValue) => onChange(name, newValue)}
        noOptionsText={noOptionsText || translate('validation.noOptionsFound')}
        openText={translate('validation.open')}
        closeText={translate('validation.close')}
        clearText={translate('validation.clear')}
        renderInput={(params) => <InputCustom {...params} label={label} error={error} name={name} />}
      />

      {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
    </FormControlCustom>
  );
}

export default memo(InputAutocomplete);